// Types pour les CGV
export interface CGVListItem {
  type: "list-item";
  title: string;
  content: string;
}

export interface CGVParagraph {
  type: "paragraph";
  content: string;
}

export interface CGVSubSection {
  type: "subsection";
  title: string;
  content: string;
}

export type CGVContent = CGVParagraph | CGVListItem | CGVSubSection;

export interface CGVArticle {
  id: number;
  title: string;
  content: CGVContent[];
}

// Données des CGV – TCAB
export const cgvArticles: CGVArticle[] = [
  {
    id: 1,
    title: "Objet",
    content: [
      {
        type: "paragraph",
        content:
          "Les présentes Conditions Générales de Vente (CGV) encadrent les modalités d’adhésion, d’accès aux installations et de participation aux cours et activités proposés par le Tennis Club de l’Agglomération du Beauvaisis (ci-après « TCAB »).",
      },
      {
        type: "paragraph",
        content:
          "Toute inscription (adhésion, cours collectifs, stage, événement) implique l’acceptation pleine et entière des présentes CGV et du règlement intérieur du club.",
      },
    ],
  },
  {
    id: 2,
    title: "Prestations proposées",
    content: [
      {
        type: "list-item",
        title: "Adhésion & licence FFT",
        content:
          "L’adhésion annuelle inclut la licence FFT et donne accès aux terrains selon disponibilités, conditions d’ouverture et règles de réservation du club.",
      },
      {
        type: "list-item",
        title: "Cours collectifs & stages",
        content:
          "Cours encadrés (jeunes et adultes) sur la période sportive, et stages ponctuels pendant les vacances scolaires ou selon planning.",
      },
      {
        type: "list-item",
        title: "Événements & animations",
        content:
          "Animations internes, tournois, matchs accompagnés, et opérations club communiqués via le site et/ou les réseaux du TCAB.",
      },
    ],
  },
  {
    id: 3,
    title: "Modalités d’inscription",
    content: [
      {
        type: "paragraph",
        content:
          "L’inscription s’effectue en ligne ou au club, via les formulaires fournis par le TCAB. Elle est définitive à réception du dossier complet et du règlement (ou accord de prise en charge).",
      },
      {
        type: "list-item",
        title: "Questionnaire de santé / certificat",
        content:
          "Conformément aux règles en vigueur, un questionnaire de santé remplace le certificat médical lorsque les conditions légales sont réunies. À défaut, un certificat pourra être demandé.",
      },
      {
        type: "subsection",
        title: "Prise en charge financière",
        content:
          "En cas de financement par un organisme tiers (collectivité, entreprise, etc.), l’accord écrit doit être transmis au TCAB avant le début de l’activité. À défaut, le membre demeure redevable des sommes dues.",
      },
    ],
  },
  {
    id: 4,
    title: "Accès aux installations & réservation",
    content: [
      {
        type: "paragraph",
        content:
          "L’accès aux terrains des différents sites du TCAB est conditionné au statut d’adhérent licencié, au respect des créneaux, à la réservation préalable (si applicable) et au règlement intérieur.",
      },
      {
        type: "list-item",
        title: "Créneaux & fermetures",
        content:
          "Les horaires peuvent varier selon les sites et la saison. Des fermetures ponctuelles (travaux, compétitions, intempéries) peuvent intervenir sans indemnisation.",
      },
      {
        type: "list-item",
        title: "Règles de jeu & matériel",
        content:
          "Tenue adaptée et respect des consignes de sécurité. Le club peut refuser l’accès en cas de non-respect.",
      },
    ],
  },
  {
    id: 5,
    title: "Tarifs, réductions & aides",
    content: [
      {
        type: "paragraph",
        content:
          "Les tarifs en vigueur sont affichés sur le site et/ou les documents d’inscription officiels. Ils incluent, sauf mention contraire, la licence FFT et l’adhésion.",
      },
      {
        type: "list-item",
        title: "Réductions famille",
        content:
          "Réduction de 10% pour 2 membres d’un même foyer fiscal et 15% à partir de 3 membres et plus, hors formule Enfant/Parent.",
      },
      {
        type: "list-item",
        title: "Aides Pass’Sport",
        content:
          "Les dispositifs d’aide (ex. Pass’Sport État, Pass’Sport Oise) sont acceptés selon conditions et justificatifs en vigueur.",
      },
      {
        type: "list-item",
        title: "Formule Enfant/Parent",
        content:
          "Formule spécifique pour jouer en libre avec son enfant, sur créneaux définis (détails sur la page Tarifs).",
      },
    ],
  },
  {
    id: 6,
    title: "Conditions de règlement",
    content: [
      {
        type: "list-item",
        title: "Échéance",
        content:
          "Le paiement est exigible à l’inscription, sauf modalités d’échelonnement convenues par le club. Les moyens de paiement acceptés sont indiqués par le TCAB.",
      },
      {
        type: "list-item",
        title: "Retard de paiement",
        content:
          "Tout retard peut entraîner des pénalités au taux légal en vigueur et/ou la suspension d’accès aux activités.",
      },
      {
        type: "list-item",
        title: "Prise en charge externe",
        content:
          "En l’absence de réception de l’accord de prise en charge avant le démarrage, le membre reste redevable de l’intégralité des sommes.",
      },
    ],
  },
  {
    id: 7,
    title: "Annulation, report & rétractation",
    content: [
      {
        type: "list-item",
        title: "Adhésions",
        content:
          "L’adhésion annuelle et la licence FFT ne sont pas remboursables une fois la saison entamée, sauf cas de force majeure apprécié par le club.",
      },
      {
        type: "list-item",
        title: "Cours collectifs / stages",
        content:
          "Tout report ou rattrapage dépend des disponibilités et des contraintes d’organisation. En cas d’annulation du fait du club, une solution (report/remplacement) est proposée.",
      },
      {
        type: "list-item",
        title: "Droit de rétractation (ventes à distance)",
        content:
          "Si l’inscription est réalisée exclusivement à distance par un consommateur, un délai légal de 14 jours peut s’appliquer, sauf exécution déjà commencée avec l’accord exprès.",
      },
      {
        type: "list-item",
        title: "Force majeure",
        content:
          "Aucun dédommagement n’est dû en cas d’événements rendant l’exécution impossible (intempéries, fermetures administratives, grèves, décisions publiques, etc.).",
      },
    ],
  },
  {
    id: 8,
    title: "Responsabilité & assurance",
    content: [
      {
        type: "paragraph",
        content:
          "Le TCAB met en œuvre les moyens nécessaires pour assurer la qualité et la sécurité des activités. Les membres s’engagent à respecter les consignes et le règlement intérieur.",
      },
      {
        type: "subsection",
        title: "Limitation de responsabilité",
        content:
          "La responsabilité du TCAB ne peut excéder le montant des sommes perçues au titre de la prestation concernée et ne saurait couvrir les dommages indirects (perte de chance, préjudice moral, etc.). Chaque adhérent doit être couvert par une assurance personnelle adaptée.",
      },
    ],
  },
  {
    id: 9,
    title: "Propriété intellectuelle & droit à l’image",
    content: [
      {
        type: "paragraph",
        content:
          "Les logos, visuels et contenus du TCAB sont protégés. Toute reproduction ou utilisation non autorisée est interdite.",
      },
      {
        type: "paragraph",
        content:
          "Le club peut solliciter l’autorisation d’utiliser l’image des adhérents (ou des mineurs via leur représentant légal) pour la promotion des activités du club (site, réseaux, affichages), conformément aux formulaires d’autorisation dédiés.",
      },
    ],
  },
  {
    id: 10,
    title: "Données personnelles (RGPD)",
    content: [
      {
        type: "paragraph",
        content:
          "Les données collectées servent à la gestion des adhésions, licences FFT, cours, compétitions et communications du club.",
      },
      {
        type: "list-item",
        title: "Base légale & durée",
        content:
          "Traitement fondé sur l’exécution contractuelle et l’intérêt légitime du club. Conservation pendant la durée de la relation et les obligations légales.",
      },
      {
        type: "list-item",
        title: "Droits des personnes",
        content:
          "Accès, rectification, opposition, effacement : via les coordonnées de contact indiquées sur le site du TCAB. Les données liées aux licences FFT peuvent être traitées par la FFT selon ses propres politiques.",
      },
    ],
  },
  {
    id: 11,
    title: "Règlement intérieur",
    content: [
      {
        type: "paragraph",
        content:
          "Le règlement intérieur complète les présentes CGV (tenue, sécurité, réservation, comportements, respect des installations). Il est opposable à tout adhérent.",
      },
    ],
  },
  {
    id: 12,
    title: "Droit applicable & litiges",
    content: [
      {
        type: "paragraph",
        content:
          "Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux compétents du ressort de Beauvais seront saisis.",
      },
    ],
  },
];

// Export par défaut
export default cgvArticles;
